import { useEffect, useState } from 'react';
import { getSponsorships, getTransactionsReferral, updateTransaction } from '../../services/Transaction_service';
import { format } from 'date-fns';
import LoaderAnnonce from '../../components/LoaderAnnonce';
import { Button, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify';

function ReferralTransactions({ clientId }: { clientId?: number }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editedAmount, setEditedAmount] = useState<number | null>(null);
  
  const parentId = localStorage.getItem('userId');
  const isAdmin = localStorage.getItem("role") === "ADMIN";

  const fetchTransactions = async () => {
    setLoading(true);
    if (clientId && parentId) {
      try {
        let data = await getSponsorships();
        data = data.filter( (t: any) => t.user_id === clientId );
        setTransactions(data);
      } catch (error) {
        console.error('Error fetching transactions', error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [clientId]);

  const handleEditClick = (id: number, commissionAmount: number) => {
    setEditingId(id);
    setEditedAmount(commissionAmount / 100);
  };

  const handleSaveClick = async (id: number) => {
    if (editedAmount !== null) {
      try {
        await updateTransaction(id, { commissionAmount: editedAmount * 100 });
        toast.success("Le montant de la commission a été mis à jour");
        fetchTransactions();
      } catch (error) {
        console.error('Error updating transaction', error);
        toast.error("Une erreur est survenue lors de la mise à jour");
      } finally {
        setEditingId(null);
      }
    }
  };

  if (loading) {
    return <LoaderAnnonce />;
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Client</th>
            <th>Montant</th>
            <th>Commission</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((sponsorship: any) => (
            <tr key={sponsorship.id}>
              <td>{sponsorship.User.email}</td>
              <td>{ Number(sponsorship.amount).toFixed(2)} € TTC</td>
              <td>{ sponsorship.percentage } %</td>
              {/* <td>
                {editingId === sponsorship.id ? (
                  <div className="d-flex align-items-center">
                    <FormControl
                      type="number"
                      value={editedAmount || ''}
                      onChange={(e) => setEditedAmount(parseFloat(e.target.value))}
                      size="sm"
                      style={{ width: '80px', marginRight: '5px' }}
                    />
                    <Button size="sm" onClick={() => handleSaveClick(sponsorship.id)}>Enregistrer</Button>
                  </div>
                ) : (
                  <b style={{ color: '#3FA33F' }}>{(sponsorship.commissionAmount / 100).toFixed(2)} € TTC</b>
                )}
                {isAdmin && editingId !== sponsorship.id && (
                  <Button variant="link" size="sm" onClick={() => handleEditClick(sponsorship.id, sponsorship.commissionAmount)}>
                    ✏️
                  </Button>
                )}
              </td> */}
              <td>{sponsorship.statut !== 'new' ? 'Payé' : 'Non payé'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ReferralTransactions;
